import "./scss/blog-via-evangelica.scss"

import { Device } from "@/utils/device"
import { isDev } from "@/utils/enviroment-detector"
import { getResourceFromS3 } from "@/utils/getResourceFromS3"
import type { BlogAppProps } from "../../../types/blog.props"

export function BlogViaEvangelica({ device, ultimasPostagens, width, height }: Readonly<BlogAppProps>) {
    function decodeHtmlEntities(str: string) {
        const doc = new DOMParser().parseFromString(str, "text/html")
        return doc.documentElement.textContent || ""
    }

    return (
        <div className="container">
            <div className="ultimas-postagens-blog clearfix flex space-between">
                {ultimasPostagens.map((materia) => (
                    <a
                        key={materia.id}
                        href={materia.url}
                        title={materia.titulo}
                        className="postagem-blog"
                    >
                        <img
                            className="lazyload principal-blog"
                            src={isDev() ? materia.url_midia_blog : materia.url_hint_blog}
                            data-src={materia.url_midia_blog}
                            alt={materia.midia_alt}
                            width={width}
                            height={height}
                        />

                        <h3>{materia.titulo}</h3>

                        <div className="postagem-info flex">
                            <span title="Data da postagem">
                                <span className="icon icon-calendario">
                                    <img
                                        className="lazyload lazyload-svg"
                                        src={isDev() ? getResourceFromS3('assets/global/blog', 'icon-calendar.svg') : materia.url_hint_blog}
                                        data-src={getResourceFromS3('assets/global/blog', 'icon-calendar.svg')}
                                        width="14"
                                        height="14"
                                        alt="Data da postagem"
                                        title="Data da postagem"
                                    />
                                </span>
                                {new Date(materia.data_criacao).toLocaleDateString("pt-BR")}
                            </span>

                            <span title="Categoria">
                                <span className="icon icon-tag">
                                    <img
                                        className="lazyload lazyload-svg"
                                        src={isDev() ? getResourceFromS3('assets/global/blog', 'icon-tag.svg') : materia.url_hint_blog}
                                        data-src={getResourceFromS3('assets/global/blog', 'icon-tag.svg')}
                                        width="14"
                                        height="14"
                                        alt="Categoria"
                                        title="Categoria"
                                    />
                                </span>
                                {materia.cat_nome}
                            </span>

                            <span title="Número de Visualizações">
                                <span className="icon icon-visualizacoes"></span>
                                {materia.num_acessos} visualizações
                            </span>
                        </div>

                        <div className="postagem-descricao">
                            {(device === Device.MOBILE || device === Device.APP) ? (
                                <p>
                                    {decodeHtmlEntities(materia.conteudo.replace(/<[^>]+>/g, "").slice(0, 197))} ...
                                </p>
                            ) : (
                                <p>
                                    {decodeHtmlEntities(materia.conteudo.replace(/<[^>]+>/g, "").slice(0, 267))} ...
                                </p>
                            )}

                            <div className="veja-mais flex justify-flex-end center">
                                continuar lendo <div className="continuar-lendo-icon"></div>
                            </div>
                        </div>
                    </a>
                ))}
            </div>
        </div>
    )
}

export default class BlogViaEvangelicaApp {
    constructor(props: BlogAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<BlogViaEvangelica {...props} />)
    }
}